export const AIRTABLE_API_KEY =
  "patEKLqAbHq5Ap3TV.a6573ed33d022192814899b77053803b658555700d7de1a441d2fd7107394ba1";
export const AIRTABLE_BASE_ID = "appobDPfd13MVHF4e";
export const AIRTABLE_TABLE_NAME = "tbldt9d3nHHoiFYmr";
export const AIRTABLE_TABLE_NAME_TRAITS = "tbl61ALglc5g4sYRF";
